export default "__VITE_ASSET__cb236c35__"